import React, { useState } from "react";

import { checkUserHasManagerRole } from "app/services/app.state.service";
import { TeamMembersForManager } from "./TeamMembersForManager";
import MemberActivityDataGridView from "../team-activities/MemberActivityDataGridView";
// import { LeavePlansForManager } from "../leave-plans/LeavePlansForManager";

export const TeamMembersManagerView = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  if (!checkUserHasManagerRole()) {
    return <div>You do not have access to this functionality.</div>;
  }

  const selectMemberHandler = (memberObj) => {
    setSelectedMember(memberObj);
  }

  return (
    <div
      className="content-container"
      style={{ width: "100%", minWidth: 0, padding: "0 16px", boxSizing: "border-box" }}
    >
      <TeamMembersForManager clickEventHandler={selectMemberHandler} />
      {selectedMember && (
        <div style={{ marginTop: 24 }}>
          <MemberActivityDataGridView selectedMember={selectedMember}/>
        </div>
      )}
    </div>
  );
};
